import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { TransferWorkshopStoreDetailModel } from 'src/app/models/maintenance/transfer-workshop-store-detail.model';
import { TransferWorkshopStoreModel } from 'src/app/models/maintenance/transfer-workshop-store.model';
import { RentalStockModel } from 'src/app/models/rental/rental-stock-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { TransferWorkshopStoreDetailCaptureTableModel } from 'src/app/models/tables/maintenance/transfer-workshop-store-detail-capture-table.model';
import { TransferWorkshopStoreDetailTableModel } from 'src/app/models/tables/maintenance/transfer-workshop-store-detail-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransferWorkshopStoreDetailService {

  constructor(private _httpClient: HttpClient) { }

  createAsync(transferWorkshopStoreDetailContract: TransferWorkshopStoreDetailModel): Observable<TransferWorkshopStoreDetailModel> {
    return this._httpClient.post<TransferWorkshopStoreDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.CreateAsync}`,
      transferWorkshopStoreDetailContract);
  }

  createSomeDetails(transferWorkshopStoreDetails: TransferWorkshopStoreDetailModel[]): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.CreateDetailsAsync}`, transferWorkshopStoreDetails);
  }

  deleteAsync(transferWorkshopStoreDetailId: number): Observable<TransferWorkshopStoreDetailModel> {
    return this._httpClient.delete<TransferWorkshopStoreDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.DeleteAsync}/${transferWorkshopStoreDetailId}`);
  }

  deleteSomeDetailsAsync(transferWorkshopStoreDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.DeleteSomeDetailsAsync}`,
      transferWorkshopStoreDetailIds);
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.ExportDetailConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllTransferWorkshopStoreDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<TransferWorkshopStoreDetailTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<TransferWorkshopStoreDetailTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.GetAllTransferWorkshopStoreDetailsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getByIdAsync(transferWorkshopStoreDetailId: number): Observable<TransferWorkshopStoreDetailModel> {
    return this._httpClient.get<TransferWorkshopStoreDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.GetByIdAsync}/${transferWorkshopStoreDetailId}`);
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.GetColumnsForDetailConsultationAsync}`);
  }

  getColumnsForCapture(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.GetColumnsForCaptureAsync}`);
  }

  getColumnsForShopStock(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.GetColumnsForShopStockAsync}`);
  }

  getDetailsByTransferWorkshopStoreIdAsync(transferWorkshopStoreId: number): Observable<Array<TransferWorkshopStoreDetailModel>> {
    return this._httpClient.get<Array<TransferWorkshopStoreDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.GetDetailsByTransferWorkshopStoreIdAsync}/${transferWorkshopStoreId}`);
  }

  getListStocksInCostCenter(transferWorkshopStore: TransferWorkshopStoreModel): Observable<Array<RentalStockModel>> {
    return this._httpClient.post<Array<RentalStockModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.GetListStocksInCostCenterAsync}`,
      transferWorkshopStore);
  }

  getStocksInCostCenterWithPagination(transferWorkshopStoreId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<RentalStockModel>> {
    const params = new HttpParams().set('transferWorkshopStoreId', transferWorkshopStoreId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<RentalStockModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.GetStocksInCostCenterWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getDetailsForCapture(page: number, limit: number, columnSort: string | null, ascendant: boolean, transferWorkshopStoreId: number): Observable<PagedResponseModel<TransferWorkshopStoreDetailCaptureTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('transferWorkshopStoreId', transferWorkshopStoreId);
    return this._httpClient.get<PagedResponseModel<TransferWorkshopStoreDetailCaptureTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.GetDetailsForCaptureAsync}`,
      { params: params }
    );
  }

  getStocksByArticleIdStoreId(rentalStockModel: RentalStockModel, transferWorkshopStoreId: number): Observable<number> {
    return this._httpClient.post<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.GetStocksByArticleIdStoreIdAsync}/${transferWorkshopStoreId}`,
      rentalStockModel);
  }

  getTransferWorkshopStoreDetailByKeys(transferWorkshopStoreId: number, storeId: number, articleId: number): Observable<TransferWorkshopStoreDetailModel> {
    const params = new HttpParams().set('transferWorkshopStoreId', transferWorkshopStoreId).set('articleId', articleId).set('storeId', storeId);
    return this._httpClient.get<TransferWorkshopStoreDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.GetTransferWorkshopStoreDetailByKeysAsync}`,
      { params: params }
    );
  }

  updateAsync(transferWorkshopStoreDetailContract: TransferWorkshopStoreDetailModel): Observable<TransferWorkshopStoreDetailModel> {
    return this._httpClient.put<TransferWorkshopStoreDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferWorkshopStoreDetail.UpdateAsync}`,
      transferWorkshopStoreDetailContract);
  }
}
